import React from "react";
import { ProgressBar, Intent } from "@blueprintjs/core";
import GoalProgressStatusBadge from "./GoalProgressStatusBadge.js";
import {
  getActualProgressType,
  getGoalNumericProgress,
  clampProgressBarValue,
  getGoalProgressBarValue,
  getStageConfig,
  getGoalProgressMax,
  getMatrixAchievedPercent,
  isGoalProgressSpecialAccount,
  formatGoalProgressPercent,
  getGoalForProgressDisplay
} from "../../utils/goalProgressUtils.js";

const GoalProgressRow = ({
  goal,
  accountId,
  subGoals = null,
  barWidth = "28%",
  showMatrix = true,
  barStyle = {}
}) => {
  if (!goal) return null;

  const displayGoal = getGoalForProgressDisplay(goal, subGoals);
  const progressType = getActualProgressType(displayGoal);
  const progress = getGoalNumericProgress(displayGoal);
  const isSpecial = isGoalProgressSpecialAccount(accountId);

  let barValue = 0;
  if (isSpecial) {
    barValue = clampProgressBarValue(progress / getGoalProgressMax(accountId));
  } else if (progressType === "stage_wise") {
    const isStageCode = [0, 1, 2, 3, 4].includes(progress);
    if (isStageCode) {
      barValue = getStageConfig(progress, displayGoal.metric_value).value / 100;
    } else {
      barValue = clampProgressBarValue(progress / 100);
    }
  } else if (progressType === "number") {
    const min = displayGoal.metric_start_range ?? 0;
    const max = displayGoal.metric_end_range ?? 100;
    const value = progress;
    if (max > min) {
      barValue = clampProgressBarValue((value - min) / (max - min));
    } else if (max === min && value >= max) {
      barValue = 1;
    }
  } else {
    barValue = getGoalProgressBarValue(displayGoal.progress, accountId);
  }

  return (
    <>
      <div style={{ width: barWidth, marginTop: "10px", flexShrink: 0, ...barStyle }}>
        <ProgressBar
          stripes={false}
          intent={Intent.NONE}
          className="goal-progress-bar bp3-no-stripes"
          value={barValue}
          style={{ width: "100%" }}
        />
      </div>
      <span
        className="weight-value"
        style={{ marginLeft: "6px", marginTop: "6px", flexShrink: 0, fontWeight: 500, color: "#555" }}
      >
        {formatGoalProgressPercent(displayGoal)}
      </span>
      <GoalProgressStatusBadge goal={displayGoal} style={{ flexShrink: 0, marginLeft: "10px" }} />
      {isSpecial && showMatrix && (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            background: "#E3F6EC",
            color: "#1F9D61",
            borderRadius: "20px",
            padding: "4px 12px",
            marginLeft: "10px",
            fontSize: "13px",
            fontWeight: 500,
            flexShrink: 0
          }}
        >
          Achievement per Matrix: <b>{getMatrixAchievedPercent(displayGoal.progress).toFixed(1)}%</b>
        </span>
      )}
    </>
  );
};

export default GoalProgressRow;
